module.exports = __webpack_public_path__ + "static/media/29ADMSPC14.ebb80c20.jpg";